import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CircularProgressWithLabel from '../../../UserAccessReview/components/CircularProgressWithLabel';
import Button from '@mui/material/Button';
import { PAGE_ICONS, PAGE_ROUTES } from 'pages/AnnualUserAccessReview/_const';
import HomeIcon from '@mui/icons-material/Home';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import Grid from '@mui/material/Grid';

const SubmissionSummary = ({
	icon,
	title,
	description,
	navigation,
	role,
	isSubmitting,
	firstName,
	lastName,
	...props
}) => {
	const history = useHistory();

	return (
		<>
			{isSubmitting ? (
				<Card variant='outlined'>
					<CardContent>
						<Stack direction='column' alignItems='center' gap={1}>
							<CircularProgressWithLabel />
							<Typography color='text.secondary'>
								Submission in progress. Please do not leave this
								page.
							</Typography>
						</Stack>
					</CardContent>
				</Card>
			) : (
				<>
					<Card variant='outlined'>
						<CardContent>
							<Stack direction='row' alignItems='center' gap={1}>
								<CheckCircleOutlineIcon
									sx={{
										color: theme =>
											theme.palette.success.light,
									}}
								/>
								<Typography variant='h5' component='div'>
									Successfully Submitted for user{' '}
									<b>
										{firstName} {lastName}
									</b>
								</Typography>
							</Stack>
							<Stack
								direction='row'
								alignItems='center'
								gap={2}
								sx={{ mt: 1.5 }}
							></Stack>
							<Typography variant='body2' sx={{ mt: 1.5 }}>
								<b>Please NOTE:</b> <br />
								<br /> Changes to <b>Job Title</b>,{' '}
								<b>Cost Center</b>, <b>Department</b>,{' '}
								<b>Manager's Email</b>, and <b>Address</b> for
								UPMC Employees and Contingent Workers will be
								temporary. These modifications will be
								overwritten by HR Direct on a nightly basis. All
								permanent changes to these values will need to
								be changed through Human Resources.
							</Typography>
						</CardContent>
						<CardActions>{navigation}</CardActions>
					</Card>
					<Grid
						container
						direction='row'
						justifyContent={'center'}
						margin={2}
					>
						<Grid item>
							<Button
								variant='contained'
								startIcon={<PAGE_ICONS.HOME />}
								onClick={() => history.push(PAGE_ROUTES.HOME)}
								sx={{ mr: 2, mb: 5 }}
							>
								Back to User Access Review Home Page
							</Button>
						</Grid>
						<Grid item>
							<Button
								variant='contained'
								startIcon={<HomeIcon />}
								onClick={() => history.push('/index.html')}
								sx={{ mr: 2, mb: 5 }}
							>
								Back to IMS Home Page
							</Button>
						</Grid>
					</Grid>
				</>
			)}
		</>
	);
};

export default SubmissionSummary;
